export const qrCodeLoginFlag = "web_eol_qr_code_login";
export const otcLoginFlag = "web_eol_otc_login";
export const webNavigationRedesignFlag = "web_eol_navigation_redesign";
export const savedEnabledFlag = "web_eol_saved";
export const recentlyViewedFlag = "web_eol_recently_viewed";
export const deviceManagementEnabledFlag = "device_management";
export const notificationCenterFlag = "epm_eol_notification_center";
export const hnsLandingFlag = "web_eol_hns_react";
export const notificationBadgeFlag = "epm_eol_notification_badge_ab_test";
